import { toast } from 'sonner';
import { downloadAppraisalDocument, type AppraisalLoanIdentity } from './appraisalWorkspaceService';

/** Reserve the tab inside the click; the existing download action checks loan access. */
export async function openAppraisalReport(loan: AppraisalLoanIdentity, reportId: string): Promise<void> {
  const tab = window.open('about:blank', '_blank');
  if (!tab) {
    toast.error('Popup blocked — please allow popups for this site');
    return;
  }
  tab.opener = null;
  let url: string | null = null;
  try {
    const blob = await downloadAppraisalDocument(loan, reportId, 'pdf', { saveToDisk: false });
    if (tab.closed) {
      return;
    }
    // The Edge download uses octet-stream for the SDK's binary response handling.
    url = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
    tab.location.href = url;
    const objectUrl = url;
    // Navigation replaces the blank window's listeners. Observe the loaded PDF
    // from its opener, retaining the Blob until the new document has loaded.
    const cleanup = window.setInterval(() => {
      let finished = tab.closed;
      try {
        const location = tab.location.href;
        finished ||= location !== 'about:blank' && (location !== objectUrl || tab.document.readyState === 'complete');
      } catch {
        // The user navigated away to a different origin; this PDF is no longer loading.
        finished = true;
      }
      if (finished) {
        window.clearInterval(cleanup);
        URL.revokeObjectURL(objectUrl);
      }
    }, 250);
  } catch {
    if (url) {
      URL.revokeObjectURL(url);
    }
    tab.close();
    toast.error('The appraisal file is not available yet.');
  }
}
